<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { FlashData } from '../types'

  type Props = {
    flash?: FlashData
    children: Snippet
  }

  let { flash, children }: Props = $props()
</script>

<div
  class="flex min-h-screen flex-col bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-gray-100"
  style="word-break: keep-all; overflow-wrap: break-word;"
>
  <header class="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
    <div class="mx-auto max-w-5xl px-4 py-3 sm:px-6 lg:px-8">
      <span class="text-lg font-semibold">구독비서</span>
    </div>
  </header>

  {#if flash?.notice || flash?.alert}
    <div class="mx-auto w-full max-w-md px-4 pt-4">
      {#if flash.notice}
        <div class="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-300">
          {flash.notice}
        </div>
      {/if}
      {#if flash.alert}
        <div class="mt-2 rounded-md border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-300">
          {flash.alert}
        </div>
      {/if}
    </div>
  {/if}

  <main class="flex flex-1 items-center justify-center px-4 py-10">
    {@render children()}
  </main>
</div>
